/**
 * Video tiles (sections/pl-feature-tiles, owner 2026-10-07: autoplay muted once loaded, a better player).
 * Nothing downloads until the tile is near the screen; then the clip loads and plays muted on a loop. It pauses when
 * scrolled away and picks up again when back, unless the visitor paused it. Two buttons: pause/play and sound.
 * With reduced motion or data saver on, it waits for a tap on play (WCAG 2.2.2: moving content can be paused).
 * A tile with data-end loops back to the start at that second, so a video's ending never plays.
 */
(() => {
  const tiles = document.querySelectorAll('[data-pl-vtile]');
  if (!tiles.length) return;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  const auto = !reduce && !saveData;

  tiles.forEach((tile) => {
    const video = tile.querySelector('video');
    const playBtn = tile.querySelector('[data-pl-vtile-play]');
    const soundBtn = tile.querySelector('[data-pl-vtile-sound]');
    let loaded = false;
    let userPaused = false;
    let inView = false;

    const load = () => {
      if (loaded) return;
      loaded = true;
      video.src = video.dataset.src;
      video.load();
    };
    const sync = () => {
      const playing = !video.paused;
      tile.classList.toggle('is-playing', playing);
      playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      const on = !video.muted;
      tile.classList.toggle('is-sound', on);
      soundBtn.setAttribute('aria-pressed', String(on));
      soundBtn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
    };
    const play = () => {
      load();
      const p = video.play();
      if (p && p.catch) p.catch(() => sync());
    };

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('volumechange', sync);

    /* "Stop the clip at": start the loop again before the video's own ending (a promo card) can play */
    const end = parseFloat(video.dataset.end);
    if (end > 0) {
      video.addEventListener('timeupdate', () => {
        if (video.currentTime >= end) video.currentTime = 0;
      });
    }

    playBtn.addEventListener('click', () => {
      if (video.paused) {
        userPaused = false;
        play();
      } else {
        userPaused = true;
        video.pause();
      }
    });
    soundBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      if (!video.muted && video.paused) {
        userPaused = false;
        play();
      }
    });
    /* a tap on the picture turns the sound on or off, as on social video */
    video.addEventListener('click', () => soundBtn.click());

    if ('IntersectionObserver' in window) {
      /* load a little before it is on screen; play and pause on visibility */
      new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) load();
      }, {rootMargin: '300px 0px'}).observe(tile);
      new IntersectionObserver((entries) => {
        inView = entries.some((e) => e.isIntersecting);
        if (inView && auto && !userPaused) play();
        else if (!inView && !video.paused) video.pause();
      }, {threshold: 0.4}).observe(tile);
    } else if (auto) {
      play();
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !video.paused) video.pause();
      else if (!document.hidden && inView && auto && !userPaused) play();
    });
    sync();
  });
})();
